import { updateGeo } from 'shared/slices/jsonQuery';
import { TAsyncThunkAction } from 'shared/types/redux';
import { updateSearchMeta } from '../../searchMeta';
import { IDistrict } from 'shared/types/geoSuggest';
import { selectSelectedDistricts } from 'shared/selectors/geo';
import { setSelectedDistricts } from 'shared/slices/geo';
import { selectJsonQuery } from 'shared/selectors/jsonQuery';
import { addDistrictToJsonQuery } from 'shared/utils/jsonQuery';

export const selectDistrict =
  ({ id }: IDistrict): TAsyncThunkAction =>
  async (dispatch, getState) => {
    const state = getState();
    const jsonQuery = selectJsonQuery(state);
    const selectedDistricts = selectSelectedDistricts(state);

    const district = { id, type: 'district' as const };
    const newSelectedDistricts = [...selectedDistricts, district];

    const newGeo = addDistrictToJsonQuery(jsonQuery, id);

    dispatch(updateGeo(newGeo));
    dispatch(setSelectedDistricts(newSelectedDistricts));
    dispatch(updateSearchMeta());
  };
